import { Alert, Button } from 'antd';
import { useAuth } from '../../context/AuthContext';
import { useSubscription, useBillingPortalUrl } from '../../api/billingApi';

export default function PastDuePaymentBanner() {
  const { currentUser } = useAuth();
  const { data: subscription } = useSubscription({ enabled: !!currentUser });
  const portal = useBillingPortalUrl();

  if (subscription?.status !== 'past_due') return null;

  const handleUpdatePayment = () => {
    portal.mutate(undefined, {
      onSuccess: (data) => {
        if (data?.url) window.location.href = data.url;
      },
    });
  };

  return (
    <Alert
      type="warning"
      showIcon
      banner
      message="Your last payment failed"
      description="Update your payment method to avoid losing access to your plan."
      action={
        <Button
          size="middle"
          type="primary"
          ghost
          loading={portal.isPending}
          onClick={handleUpdatePayment}
        >
          Update payment method
        </Button>
      }
    />
  );
}